<input
  type="range"
  class="w-full {{ rangeClasses }}"
  [min]="min"
  [max]="max"
  [step]="step"
  [value]="value"
  [disabled]="disabled"
  (input)="onInputChange($event)"
  (change)="onInputChange($event)" />

@if (showSteps && getStepMarkers().length > 0) {
  <div class="flex w-full justify-between px-2.5 mt-2 text-xs">
    @for (marker of getStepMarkers(); track marker) {
      <span>|</span>
    }
  </div>
}




